import React, { useState } from 'react';
import { FiDownload } from 'react-icons/fi';
import { studentAPI } from '../../services/api';
import { downloadBlobResponse } from '../../utils/downloadFile';

const ExportButtons = ({ filters, totalStudents }) => {
  const [exporting, setExporting] = useState(false);

  const handleExportCSV = async () => {
    try {
      setExporting(true);

      // Build query params from current filters
      const params = {};
      if (filters.cluster) params.cluster = filters.cluster;
      if (filters.search) params.search = filters.search;
      if (filters.gradeLevel) params.gradeLevel = filters.gradeLevel;
      if (filters.campus) params.campus = filters.campus;

      // Make API call
      const response = await studentAPI.exportCSV(params);

      downloadBlobResponse(response, `student_survey_results_${new Date().toISOString().split('T')[0]}.csv`);
    } catch (error) {
      console.error('Error exporting CSV:', error);
      alert(`Failed to export CSV: ${error.message || 'Unknown error'}`);
    } finally {
      setExporting(false);
    }
  };

  // Build filter description
  const getFilterDescription = () => {
    const activeFilters = [];
    if (filters.cluster) activeFilters.push(`Cluster: ${filters.cluster}`);
    if (filters.gradeLevel) activeFilters.push(`Grade: ${filters.gradeLevel}`);
    if (filters.campus) activeFilters.push(`Campus: ${filters.campus}`);
    if (filters.search) activeFilters.push(`Search: ${filters.search}`);

    if (activeFilters.length === 0) {
      return 'All students';
    }
    return activeFilters.join(', ');
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-1">Export Survey Results</h3>
          <p className="text-sm text-gray-600">
            Download CSV file with current filters: <span className="font-medium">{getFilterDescription()}</span>
            {totalStudents !== undefined && (
              <span className="text-gray-500"> ({totalStudents} {totalStudents === 1 ? 'student' : 'students'})</span>
            )}
          </p>
        </div>
        <button
          onClick={handleExportCSV}
          disabled={exporting}
          className="
            px-6 py-2.5 rounded-lg font-medium text-sm
            bg-green-600 text-white hover:bg-green-700
            disabled:bg-green-400 disabled:cursor-not-allowed
            transition-all flex items-center space-x-2 shadow-sm hover:shadow-md
          "
        >
          {exporting ? (
            <>
              <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Exporting...</span>
            </>
          ) : (
            <>
              <FiDownload className="w-5 h-5" />
              <span>Export to CSV</span>
            </>
          )}
        </button>
      </div>

      {/* Info text */}
      <div className="mt-3 pt-3 border-t border-gray-200">
        <p className="text-xs text-gray-500">
          <strong>CSV includes:</strong> Student information, recommendations with match scores and reasoning,
          and student-selected career clusters - all in a single row per student.
        </p>
      </div>
    </div>
  );
};

export default ExportButtons;
